module.exports = __webpack_public_path__ + "static/media/profiel scree.8a762956.png";